import { Container, Grid } from "@material-ui/core";
import Menu from "../../Components/Menu";
import styled from "@emotion/styled";
import S4 from "../../img/About_S4.png";

const S4_About = () => {
  const MainDiv = styled.div`
  `;
  const Span = styled.span`
    color: #ffffff;
    font-size: 44px;
    text-transform: uppercase;
    font-weight: 600;
    padding-bottom: 10px;
    @media screen and (max-width:1150px){
    font-size: 36px;
    }
     @media screen and (max-width:599px){
      font-size: 27px;
    }
  `;
  const P = styled.p`
    color: #ffffff;
    padding-top: 30px;
  `;
  return (
    <MainDiv className="py-5 my-5" id="Home">
      <Container>
        <Grid
          container
          justifyContent="center"
          alignContent="center"
          alignItems="center"
          className=""
        >
          
          <Grid xs={12} sm={12} md={5} className="text-left">
            <h1 className="fontweight">
              <Span>
                <Span style={{ borderBottom: "7px solid #B82E3C" }}>
                &nbsp; OUR VISION
                </Span>
              </Span>
            </h1>
            <P>
            Our vision is to become essential for our customers, in the scope of our services, throughout the world in realization of our customers business expectations in complete solutions.
            </P>
          </Grid>
          <Grid xs={12} sm={12} md={6} className="">
            <img src={S4} className="img-fluid w-100" />
          </Grid>
          <Grid xs={12} sm={12} md={1}></Grid>
        </Grid>
      </Container>
    </MainDiv>
  );
};

export default S4_About;
